"use client";
import { React } from "react";
import Header from "./../components/Header";
import LoginForm from "./../components/LoginForm";

const Login = () => {
  const responseFacebook = (response) => {
    console.log(response);
    if (response.accessToken) {
      // Send accessToken to backend
      fetch("/api/auth/verify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ accessToken: response.accessToken }),
      });
    }
  };

  return (
    <>
      <Header />
      <LoginForm />
    </>
  );
};

export default Login;
